var _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransparentPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1593,
    cy: 27.1593,
    r: 26.6593,
    fill: "url(#paint0_radial_1063_32457)",
    stroke: "#FBD161",
    strokeDasharray: "8 8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1063_32457",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1593 27.1593) rotate(90) scale(27.1593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD161",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentPlanet);
export default __webpack_public_path__ + "static/media/transparent-planet.631d08c6896c97240c42f6c63d40dabf.svg";
export { ForwardRef as ReactComponent };